module.exports = __webpack_public_path__ + "static/img/MP@3x.b8c7d0eb.png";